import '../styles/fonts.css';
import '../styles/reset.css';
import '../styles/globals.css';

import { KioskProvider } from '@auth-v2';
import { GlobalLoader } from '@loaders';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@queries';
import { StoreProvider } from '@store';

import { ROUTES } from '../utils/routes';

import { BoothRouter } from './BoothRouter';

const authPaths = [ROUTES.LOGIN, ROUTES.REGISTER, ROUTES.CONFIRM, ROUTES.RESET_PASSWORD, ROUTES.BOOTH_LOGIN];

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <StoreProvider>
                <KioskProvider authPaths={authPaths} loginPath={ROUTES.LOGIN} boothLoginPath={ROUTES.BOOTH_LOGIN}>
                    <GlobalLoader>
                        <BoothRouter />
                    </GlobalLoader>
                </KioskProvider>
            </StoreProvider>
        </QueryClientProvider>
    );
}
